import { useMutation } from '@apollo/client';
import { DeleteLinkedItemsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import { evictField } from '@/utils/graphqlUtils';

import { useUnlinkItemsTRPC } from './useUnlinkItemsTRPC';

export const useUnlinkItems = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  const [unlinkGraphQL, graphqlState] = useMutation(DeleteLinkedItemsDocument, {
    update: (cache) => {
      evictField(cache, 'linked_item');
      evictField(cache, 'control');
      evictField(cache, 'control_group');
      evictField(cache, 'action');
      evictField(cache, 'appetite');
      evictField(cache, 'issue');
      evictField(cache, 'document');
      evictField(cache, 'obligation');
      evictField(cache, 'obligation_change');
      evictField(cache, 'risk');
      evictField(cache, 'acceptance');
      evictField(cache, 'indicator');
      evictField(cache, 'risk_score');
    },
  });

  const trpcMutation = useUnlinkItemsTRPC();

  const unlinkItems = async (ids: string[]) => {
    if (trpcEnabled) {
      return trpcMutation.unlinkItems(ids);
    }

    await unlinkGraphQL({
      variables: {
        Ids: ids,
      },
    });
  };

  if (trpcEnabled) {
    return {
      unlinkItems,
      loading: trpcMutation.loading,
      error: trpcMutation.error,
    };
  }

  return {
    unlinkItems,
    loading: graphqlState.loading,
    error: graphqlState.error,
  };
};
